<template>
  <div class="daily-weekly-tasks" :style="cssVars()">
    <!-- 周任务 -->
    <div class="weekly-bonus" v-if="!newerTask.length != 0 && weekTask && weekTask.length > 0 && weekTaskData">
      <div class="title">
        <span>{{ $t('lang.BaseCommon.k082') }}</span>
        <!-- prettier-ignore -->
        <i>
          {{ weekTaskData.state == 2 ? weekTaskData.reward : 0 }}/{{ weekTaskData.reward }}<img :src="getMatchImg('beans')" alt="" />
        </i>
      </div>
      <div class="complete">
        <div class="complete-time">
          <span>{{ weekTaskData.title }}</span>
          <div class="time">
            ({{ replaceTime(getWeekStartAndEnd(weekTaskData.curDay).monday) }}-{{ replaceTime(getWeekStartAndEnd(weekTaskData.curDay).sunday) }})
          </div>
        </div>
        <!-- 周任务完成领取按钮 -->
        <div
          class="complete-btn"
          :class="{ completeSubmit: weekTaskData.state == 1, completed: weekTaskData.state == 2 }"
          @click="weekTaskData.state == 1 && handleWeekSubmit()"
        >
          <div v-if="weekTaskData.state == 0 || weekTaskData.state == 1">
            {{ weekTaskData.reward }}
            <img :src="getMatchImg('beans')" alt="" />
          </div>
          <div v-if="weekTaskData.state == 2">
            <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/check.webp" alt="" />
          </div>
        </div>
      </div>
      <div class="day-list">
        <div class="day" v-for="(item, index) in weekTaskData.weeks" :key="index">
          <div class="dayNotStartbg" v-if="Date.parse(item.day) >= Date.parse(weekTaskData.curDay)">
            <!-- 等待中 -->
            <div class="finish-icon icon-notstarted"></div>
            <span>{{ weekList[index] }}</span>
          </div>
          <div class="day-bg" :class="{ failActive: !item.ifFinished }" v-else>
            <!-- 完成或者未完成 -->
            <div class="finish-icon icon-complete" v-if="item.ifFinished"></div>
            <img class="finish-icon" v-else src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/fail_icon.webp" alt="" />
            <span>{{ weekList[index] }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 每日任务 -->
    <div class="daily-tasks">
      <div class="title">
        <span>{{ $t('lang.BaseCommon.k094') }}</span>
        <!-- prettier-ignore -->
        <i v-if="total" :class="{ lockedColor: newerTask.length > 0 }">
          {{ newerTask.length > 0 ? 'Locked' : total.reward }}/{{ total.total }}<img :src="getMatchImg('beans')" alt="" />
        </i>
      </div>
      <template v-if="dailyTask && dailyTask.length > 0">
        <div class="list-box">
          <!-- 每日任务的蒙层 -->
          <div class="daily-task-mask" v-if="newerTask && newerTask.length > 0">
            <div class="lock">
              <div class="lock-flag"></div>
              <div class="text">
                {{ $t('lang.HostessTasks.k011') }}
                <i>{{ handleOneText($t('lang.HostessTasks.k016'), '%s', total.total) }}</i>
              </div>
            </div>
          </div>
          <!-- 每日任务的内容 -->
          <div class="daily-task-list" :class="{ 'glass-view': newerTask && newerTask.length }" v-for="(item, index) in dailyTask" :key="index">
            <div v-if="bubbleShow && item.customState === 1 && index === 0" class="bubble-tips">
              <div class="bubble-content">
                <span>{{ $t('lang.HostessTasks.k001') }}</span>
                <div class="bubble-tran"></div>
              </div>
            </div>
            <div class="left-btn-text">
              <span class="text">{{ handleTitle1(item.title) }}</span>
              <!--点击 按钮 -->
              <!-- 多个条件节点 -->
              <div class="left-btn" v-if="item.conditions && item.conditions.length > 1">
                <div class="left-btn-box arrow left-nav" v-if="handleStatus(item.conditions) == 0" @click="handleArrow(item)">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/arrow.webp" alt="" />
                </div>

                <div class="left-btn-box success left-nav" v-if="handleStatus(item.conditions) == 1" @click="handleRward(item)">
                  {{ $t('lang.BaseCommon.k010') }}
                </div>

                <div class="left-btn-box checked left-nav" v-if="handleStatus(item.conditions) == 2">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/check.webp" alt="" />
                </div>
              </div>
              <!-- 一个条件节点 -->
              <div class="left-btn" v-else>
                <div class="left-btn-box arrow left-nav" v-if="item.conditions[0].state == 0" @click="handleArrow(item)">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/arrow.webp" alt="" />
                </div>
                <div class="left-btn-box success left-nav" v-if="item.conditions[0].state == 1" @click="handleRward(item)">
                  {{ $t('lang.BaseCommon.k010') }}
                </div>
                <div class="left-btn-box checked left-nav" v-if="item.conditions[0].state == 2">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/check.webp" alt="" />
                </div>
              </div>
            </div>
            <div class="time-num-money">
              <span>{{ handleTitle2(item.title) }}</span>
              <div class="btn-num" v-if="item.conditions && item.conditions.length == 1">
                {{ item.conditions[0].rewardList[0].rewardPropNum }}
                <img :src="getMatchImg('beans')" alt="" />
              </div>
            </div>
            <!-- 进度条有多个状态的 -->
            <div class="progress-three" v-if="item.conditions && item.conditions.length > 1">
              <div class="progress-line ar-rogress-line">
                <div class="node">
                  <div class="node-item" :class="{ arNodeItem: $i18n.locale == 'ar' }"></div>
                  <template v-for="(child, index) in item.conditions">
                    <template v-if="$i18n.locale != 'ar'">
                      <div
                        :key="index"
                        class="node-item"
                        :class="{ arNodeItem: $i18n.locale == 'ar', taskSuccess: child.state == 2, checked: child.state == 1 }"
                        :style="{ left: `${child.goal / handleComputeNodeValue(item.conditions)}%` }"
                      >
                        <div class="node-top">
                          <div>
                            {{ child.rewardList[0].rewardPropNum }}
                            <img :src="getMatchImg('beans')" alt="" />
                          </div>
                        </div>
                        <div class="node-bottom">
                          {{ child.goalDisplay }}
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        class="node-item"
                        :class="{ arNodeItem: $i18n.locale == 'ar', taskSuccess: child.state == 2, checked: child.state == 1 }"
                        :style="{ right: `${child.goal / handleComputeNodeValue(item.conditions)}%` }"
                      >
                        <div class="node-top">
                          <div>
                            {{ child.rewardList[0].rewardPropNum }}
                            <img :src="getMatchImg('beans')" alt="" />
                          </div>
                        </div>
                        <div class="node-bottom">
                          {{ child.goalDisplay }}
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <van-progress
                  class="progress-bar"
                  stroke-width="4"
                  track-color="var(--theme-progress-track-color)"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  :show-pivot="true"
                  :pivot-text="threeMaxProc(item.conditions)"
                  :percentage="handleComputeProgress(item.conditions)"
                />
              </div>
            </div>
            <!-- 进度条 Online Call -->
            <div class="online-call" v-if="item.conditions && item.conditions.length == 1">
              <!-- Online -->
              <div class="progress-bar-box progress-bar-box-online" v-if="item.conditions[0].targetOnlineTimeRangeSeconds">
                <span>{{ $t('lang.HostessTasks.k015') }}</span>
                <van-progress
                  class="progress-bar"
                  stroke-width="4"
                  track-color="var(--theme-progress-track-color)"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  :show-pivot="true"
                  :pivot-text="onlineProc(item.conditions[0].onlineTimeRangeSeconds)"
                  :percentage="handlePercentageOnlineCall(item.conditions[0].onlineTimeRangeSeconds, item.conditions[0].targetOnlineTimeRangeSeconds)"
                />
                <div class="state-number">
                  <div
                    class="state-number-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess:
                        handlePercentageOnlineCall(item.conditions[0].onlineTimeRangeSeconds, item.conditions[0].targetOnlineTimeRangeSeconds) >= 100,
                    }"
                  >
                    <span>{{ handleSecondsHours(item.conditions[0].targetOnlineTimeRangeSeconds) }}{{ $t('lang.HostessTasks.k012') }}</span>
                  </div>
                </div>
              </div>
              <!-- Call duration -->
              <div class="progress-bar-box" v-if="item.conditions[0].targetCallTimeRangeSeconds">
                <span>{{ $t('lang.BaseCommon.k036') }}</span>
                <van-progress
                  class="progress-bar"
                  stroke-width="4"
                  track-color="var(--theme-progress-track-color)"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  :show-pivot="true"
                  :pivot-text="callProc(item.conditions[0].callTimeRangeSeconds)"
                  :percentage="handlePercentageOnlineCall(item.conditions[0].callTimeRangeSeconds, item.conditions[0].targetCallTimeRangeSeconds)"
                />
                <div class="state-number">
                  <div
                    class="state-number-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess:
                        handlePercentageOnlineCall(item.conditions[0].callTimeRangeSeconds, item.conditions[0].targetCallTimeRangeSeconds) >= 100,
                    }"
                  >
                    <span>{{ handleSecondsMinutes(item.conditions[0].targetCallTimeRangeSeconds) }}{{ $t('lang.HostessTasks.k013') }}</span>
                  </div>
                </div>
              </div>

              <div class="progress-bar-box" v-if="!item.conditions[0].targetCallTimeRangeSeconds">
                <van-progress
                  class="progress-bar"
                  stroke-width="4"
                  track-color="var(--theme-progress-track-color)"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  :show-pivot="true"
                  :pivot-text="threeMaxProc(item.conditions)"
                  :percentage="(item.conditions[0].proc / item.conditions[0].goal) * 100"
                />
                <div class="state-number">
                  <div
                    class="state-number-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess: item.conditions[0].goal == item.conditions[0].proc,
                    }"
                  >
                    <span>{{ item.conditions[0].goalDisplay }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <van-popup class="van-popup-box" v-model="showRewardDia" @close="closeShowRewardDia" :lock-scroll="false">
        <div class="reward-dia">
          <img class="bulibuli" :src="getMatchImg('reward-bg')" alt="" />
          <span class="number">x{{ rewardNumber }}</span>
        </div>
        <div class="reward-dia-btn">
          <span @click="handleRewardDiaConfirm">{{ $t('lang.BaseCommon.k028') }}</span>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { apiFetchWeekTaskSubmit } from '@/api/imee'
import { mixin } from '../mixin.js'
import { pageCssVars } from '../z-style-cfg.js'

export default {
  mixins: [mixin, pageCssVars],
  props: {
    dailyTask: [],
    weekTask: [],
    newerTask: [],
  },
  data() {
    return {
      weekTaskData: this.weekTask && this.weekTask[0],
      // 星期list
      weekList: {
        0: this.$t('lang.HostessTasks.k004'),
        1: this.$t('lang.HostessTasks.k008'),
        2: this.$t('lang.HostessTasks.k009'),
        3: this.$t('lang.HostessTasks.k007'),
        4: this.$t('lang.HostessTasks.k003'),
        5: this.$t('lang.HostessTasks.k005'),
        6: this.$t('lang.HostessTasks.k006'),
      },
    }
  },
  watch: {
    dailyTask(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.total = this.taskTotal(newVal)
      }
    },
    weekTask(newVal) {
      this.weekTaskData = newVal && newVal[0]
    },
  },
  methods: {
    // 领取周任务
    handleWeekSubmit() {
      if (this.weekTaskData && this.weekTaskData.weeks && this.weekTaskData.weeks.length) {
        apiFetchWeekTaskSubmit(this.weekTaskData.weeks[0].day, this.weekTaskData.weekTaskId).then((res) => {
          if (res) {
            this.showRewardDia = true
            this.rewardNumber = this.weekTaskData.reward
          }
        })
      }
    },
  },
  created() {
    this.getTotalNum(this.dailyTask)
  },
}
</script>

<style lang="less" scoped>
.daily-weekly-tasks {
  // 周任务 weekly-bonus
  .weekly-bonus {
    margin-bottom: 40px;

    .title {
      display: flex;
      align-items: baseline;
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-600);
      color: #333333;
      i {
        display: flex;
        align-items: center;
        margin: 0 8px;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-500);
        color: var(--theme-title-count-color);
        img {
          width: 13px;
          height: 13px;
          margin: 0 5px;
        }
      }
    }

    .complete {
      display: flex;
      justify-content: space-between;
      margin: 20px 0 10px 0;

      .complete-time {
        height: 20px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-500);
        color: #333333;
        line-height: var(--lh-body-20);
        .time {
          font-family: var(--string-font);
          font-size: var(--fs-12);
          font-weight: var(--fw-400);
          color: #999999;
          line-height: var(--lh-body-20);
        }
      }

      .complete-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 70px;
        height: 24px;
        padding: 0 12px;
        background: linear-gradient(90deg, #cccbd0 0%, #bfbcc3 100%);
        border-radius: 16px;
        color: #fff;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
          > img {
            width: 13px;
            height: 13px;
            margin: 0 2px;
          }
        }
        &.completeSubmit {
          background: linear-gradient(90deg, #fdd305 0%, #ffba27 100%);
        }
        &.completed {
          background: linear-gradient(90deg, #cccbd0 0%, #bfbcc3 100%);
        }
      }
    }

    .day-list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .day {
        width: 42px;
        height: 60px;
        margin: 18px 0 0;
        border-radius: 21px 21px 4px 4px;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-400);
        color: #999999;
        line-height: var(--lh-label-16);
        overflow: hidden;

        .finish-icon {
          width: 24px;
          height: 24px;
          margin-bottom: 6px;
        }
        .icon-notstarted {
          background: var(--theme-notstarted-icon);
          background-size: 100% 100%;
        }
        .icon-complete {
          background: var(--theme-complete-icon);
          background-size: 100% 100%;
        }
      }

      .day-bg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        &.failActive {
          background-color: #f2f2f2;
        }
      }

      .dayNotStartbg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: var(--theme-day-not-start-bg);
      }
    }
  }

  // 日任务 daily-tasks
  .daily-tasks {
    font-family: var(--string-font);

    .title {
      display: flex;
      align-items: baseline;
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-600);
      color: #333333;
      i {
        display: flex;
        align-items: center;
        margin: 0 8px;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-500);
        color: var(--theme-title-count-color);
        &.lockedColor {
          color: #999;
        }
        img {
          width: 13px;
          height: 13px;
          margin: 0 5px;
        }
      }
    }

    .list-box {
      position: relative;

      .daily-task-mask {
        position: absolute;
        z-index: 100;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(248, 243, 250, 0.9);
        border: 1px solid #f8f3fa;
        border-radius: 8px;
        @supports (backdrop-filter: blur(4px)) {
          background: rgba(248, 243, 250, 0.1);
          backdrop-filter: blur(4px);
        }

        .lock {
          position: absolute;
          top: 50%;
          left: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          transform: translate(-50%, -50%);

          .lock-flag {
            width: 34px;
            height: 42px;
            background: var(--theme-lock-flag);
            background-size: 100% 100%;
          }

          .text {
            width: 192px;
            margin-top: 10px;
            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-500);
            color: #333333;
            line-height: var(--lh-body-20);
            text-align: center;
            white-space: pre-wrap;
            i {
              color: var(--theme-lock-highlight);
            }
          }
        }
      }

      .daily-task-list {
        position: relative;
        z-index: 10;
        width: 100%;
        padding: 12px 0 1px;
        margin: 10px 0;
        background: var(--theme-task-list-bg);
        border-radius: 8px;

        &.glass-view {
          filter: blur(4px);
          -webkit-filter: blur(4px);
        }

        .bubble-tips {
          position: absolute;
          top: -40px;
          right: 0;
          min-width: 180px;
          padding: 0 10px;
          line-height: 32px;
          border-radius: 6px;
          background-color: #333333;

          .bubble-content {
            position: relative;
            width: 100%;
            height: 100%;
            text-align: center;

            span {
              font-family: var(--string-font);
              font-size: var(--fs-16);
              font-weight: var(--fw-400);
              color: #e6e5e7;
              line-height: var(--lh-body-24);
              text-align: center;
            }

            .bubble-tran {
              position: absolute;
              right: 20%;
              bottom: -8px;
              z-index: -1;
              width: 0;
              height: 0;
              transform: translateX(-50%);
              border-top: 10px solid #333333;
              border-right: 7px solid transparent;
              border-left: 7px solid transparent;
            }
          }
        }

        .left-btn-text {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 4px;
          padding: 0 12px;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-500);
          line-height: var(--lh-body-20);
          color: #333333;

          .left-btn {
            min-width: 70px;
            height: 24px;

            .left-btn-box {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              padding: 0 5px;
              border-radius: 16px;
              > img {
                width: 18px;
                height: 18px;
              }
              &.arrow {
                background: var(--theme-arrow-btn-bg);
              }
              &.success {
                background: var(--theme-success-btn-bg);
                color: #fff;
              }
              &.checked {
                background: linear-gradient(90deg, #cccbd0 0%, #bfbcc3 100%);
              }
            }
          }
        }

        .time-num-money {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          font-family: var(--string-font);
          font-size: var(--fs-12);
          line-height: var(--lh-body-20);
          color: #999999;

          .btn-num {
            display: flex;
            align-items: center;
            > img {
              width: 13px;
              margin: 0 2px;
            }
          }
        }

        .progress-three {
          position: relative;
          width: 100%;
          margin: 10px auto;

          .progress-line {
            width: 100%;
            padding: 24px 32px 20px 20px;

            .node {
              position: relative;
              display: flex;
              width: 100%;

              .node-item {
                position: absolute;
                top: 0;
                z-index: 100;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: var(--theme-node-bg);
                transform: translateY(-30%);

                .node-top {
                  position: absolute;
                  top: -14px;
                  left: 50%;
                  font-family: var(--string-font);
                  font-size: var(--fs-12);
                  font-weight: var(--fw-400);
                  line-height: var(--lh-label-16);
                  color: #999999;
                  transform: translate(-50%, -50%);
                  > div {
                    display: flex;
                    align-items: center;
                    > img {
                      width: 13px;
                      margin: 0 2px;
                    }
                  }
                }

                .node-bottom {
                  position: absolute;
                  top: 23px;
                  left: 50%;
                  z-index: 10;
                  font-family: var(--string-font);
                  font-size: var(--fs-10);
                  font-weight: var(--fw-400);
                  line-height: var(--lh-label-14);
                  color: #333333;
                  transform: translate(-50%, -50%);
                }

                &:nth-child(1) {
                  left: 0;
                  background-color: rgba(255, 255, 255, 0);
                }
                &:nth-child(2) {
                  left: 33.3%;
                }
                &:nth-child(3) {
                  left: 66.6%;
                }
                &:nth-child(4) {
                  left: 99.4%;
                }

                &.arNodeItem:nth-child(1) {
                  right: 0 !important;
                  left: auto !important;
                  background-color: rgba(255, 255, 255, 0);
                }

                &.taskSuccess {
                  width: 12px;
                  height: 12px;
                  background: var(--theme-success-icon);
                  background-size: 100% 100%;
                }

                &.checked {
                  width: 12px;
                  height: 12px;
                  background: url('~@/assets/packageAssets/views/P1_Girls/HostessTasks/default/checked_icon.webp');
                  background-size: 100% 100%;
                }
              }
            }

            .progress-bar {
              border-radius: 20px;
              ::v-deep .van-progress__portion {
                background: var(--theme-progress-color) !important;
              }
            }
          }
        }

        .online-call {
          padding: 10px 30px 10px 20px;

          .progress-bar-box {
            position: relative;
            width: 100%;
            margin: 0 0 22px;

            > span {
              display: block;
              margin-bottom: 5px;
              font-family: var(--string-font);
              font-size: var(--fs-10);
              font-weight: var(--fw-400);
              line-height: var(--lh-label-14);
              color: #333333;
            }

            &.progress-bar-box-online {
              margin: 0 0 30px;
            }

            .progress-bar {
              border-radius: 20px;
              ::v-deep .van-progress__portion {
                background: var(--theme-progress-color) !important;
              }
            }

            .state-number {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;

              .state-number-box {
                position: absolute;
                top: -6px;
                left: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 8px;
                height: 8px;
                margin-left: -4px;
                border-radius: 50%;
                background-color: var(--theme-node-bg);

                > span {
                  position: absolute;
                  top: 16px;
                  font-family: var(--string-font);
                  font-size: var(--fs-10);
                  font-weight: var(--fw-500);
                  line-height: var(--lh-label-14);
                  color: #333333;
                }

                &.stateNumberSuccess {
                  top: -8px;
                  left: 99.4%;
                  width: 12px;
                  height: 12px;
                  background: var(--theme-success-icon);
                  background-size: 100% 100%;
                }

                &.arStateNumberBox {
                  right: 99.4% !important;
                  left: auto !important;
                }

                &.arStateNumberSuccess {
                  right: 99.4% !important;
                  left: auto !important;
                }
              }
            }
          }
        }
      }
    }

    // 奖励弹窗
    ::v-deep .van-popup {
      background-color: transparent;
    }

    .van-popup-box {
      width: 350px;
      padding: 0 20px 40px;
      overflow: hidden;

      .reward-dia {
        position: relative;
        width: 300px;
        height: 300px;
        margin: 0 auto;
        overflow: hidden;
        font-family: var(--string-font);

        .bulibuli {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 1;
          display: block;
          width: 300px;
          height: 300px;
          margin-top: -150px;
          margin-left: -150px;
        }

        .number {
          position: absolute;
          top: 55%;
          left: 50%;
          z-index: 20;
          display: block;
          margin-top: 30px;
          font-family: var(--number-font);
          font-size: var(--fs-48);
          line-height: var(--lh-display-58);
          color: #ffac00;
          transform: translate(-50%, 0);
          -webkit-text-stroke: 1px #ffffff;
        }
      }

      .reward-dia-btn {
        width: 100%;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        color: var(--theme-reward-btn-color);
        text-align: center;

        > span {
          padding: 8px 30px;
          margin: 0 auto;
          line-height: 40px;
          border-radius: 20px;
          background: var(--theme-reward-btn-bg);
        }
      }
    }
  }

  // 进度条 pivot（全局 deep，作用于组件内 van-progress）
  ::v-deep .van-progress__pivot {
    position: absolute;
    top: calc(50% + 3px);
    left: 100% !important;
    z-index: 1000 !important;
    min-width: 20px;
    border-radius: 2px;
    background-color: var(--theme-pivot-color) !important;
    transform: translate(-50%, 50%) !important;
    &::after {
      position: absolute;
      top: -3px;
      left: 50%;
      z-index: -1;
      width: 0;
      height: 0;
      transform: translateX(-50%);
      border-right: 6px solid transparent;
      border-bottom: 4px solid var(--theme-pivot-color);
      border-left: 6px solid transparent;
      content: '';
    }
  }

  .arProgressBar {
    ::v-deep .van-progress__pivot {
      right: 100% !important;
      left: auto !important;
      background-color: var(--theme-pivot-color) !important;
      transform: translate(50%, 50%) !important;
      &::after {
        position: absolute;
        top: -3px;
        left: 50%;
        z-index: -1;
        width: 0;
        height: 0;
        transform: translateX(-50%);
        border-right: 6px solid transparent;
        border-bottom: 4px solid var(--theme-pivot-color);
        border-left: 6px solid transparent;
        content: '';
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .daily-weekly-tasks {
    // .daily-weekly-tasks > .weekly-bonus
    .weekly-bonus {
      .complete {
        .complete-btn.completed {
          > div > img {
            transform: rotateY(180deg) !important;
          }
        }
      }
    }

    // .daily-weekly-tasks > .daily-tasks
    .daily-tasks {
      .list-box {
        .daily-task-list {
          .bubble-tips {
            right: auto !important;
            left: 0 !important;

            .bubble-content {
              .bubble-tran {
                right: auto !important;
                left: 20% !important;
              }
            }
          }

          .left-btn-text {
            .left-btn {
              .left-btn-box {
                &.arrow > img,
                &.checked > img {
                  transform: rotateY(180deg) !important;
                }
              }
            }
          }

          .progress-three {
            .progress-line {
              padding: 24px 20px 20px 32px !important;
            }
          }

          .online-call {
            padding: 10px 20px 10px 30px !important;
          }
        }
      }
    }
  }
}
</style>
